import api from "./api";
import { StoredPassword, CreateStoredPassword, UpdateStoredPassword } from "../types/password.types";

export const passwordService = {
  async getAll(groupId?: string): Promise<StoredPassword[]> {
    const params = groupId ? { groupId } : {};
    const response = await api.get("/stored-passwords", { params });
    return response.data;
  },

  async getById(id: string): Promise<StoredPassword> {
    const response = await api.get(`/stored-passwords/${id}`);
    return response.data;
  },

  async getDecryptedPassword(id: string): Promise<{ password: string }> {
    const response = await api.get(`/stored-passwords/${id}/decrypt`);
    return response.data;
  },

  async create(data: CreateStoredPassword): Promise<StoredPassword> {
    const response = await api.post("/stored-passwords", data);
    return response.data;
  },

  async update(id: string, data: UpdateStoredPassword): Promise<StoredPassword> {
    const response = await api.patch(`/stored-passwords/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/stored-passwords/${id}`);
  },
};
